import gql from 'graphql-tag';

export default gql`
  fragment preleadCustomizeItemNumberFragment on PreleadCustomizeItemNumber {
    id
    value
    clientPreleadCustomizeItemId
  }
`;
